import { Injectable, signal } from '@angular/core';

import { ProactiveActivityItem, ProactiveItemView } from './proactive-activity.service';

export type EmailReviewDialogState = {
    card: ProactiveActivityItem;
    sectionLabel: string;
    rowIndex: number;
    item: ProactiveItemView;
} | null;

/** Singleton holder for the email-review pop-out modal. Both surfaces
 *  (rail row click + chat system-event-card "View / Edit" button) push
 *  state here; one dialog instance at the page root reads it. */
@Injectable({ providedIn: 'root' })
export class EmailReviewDialogService {
    readonly current = signal<EmailReviewDialogState>(null);

    open(state: NonNullable<EmailReviewDialogState>): void {
        this.current.set(state);
    }

    close(): void {
        this.current.set(null);
    }
}
